<template>
  <transition name="modal">
    <div class="modal-mask modal-mask--alert">
      <div class="modal-wrapper">
        <div class="modal-container">

          <div class="modal-body text-center">
            <slot></slot>
          </div>

          <div v-if="footerConfirm" class="modal-footer">
            <div v-if="allowSkip" class="tb-checkbox pull-left">
              <input
                type="checkbox"
                class="no-margin"
                id="skipConfirmation"
                data-entity="producer-alert-skip"
                data-test="producer-alert-skip"
                @change="$emit('skipConfirmation')"
              >
              <label class="checkbox" for="skipConfirmation">Don't show this again</label>
            </div>
            <button
              class="tb-btn tb-btn-text medium-em"
              data-entity="producer-alert-cancel"
              data-test="producer-alert-cancel"
              @click="$emit('close')"
            >No, cancel.</button>
            <button
              class="tb-btn tb-btn-contained high-em"
              data-entity="producer-alert-confirm"
              data-test="producer-alert-confirm"
              @click="$emit('confirm')"
            >Yes, I'm sure.</button>
          </div>

          <div v-if="footerClose" class="modal-footer">
            <button
              class="tb-btn tb-btn-text medium-em"
              data-entity="producer-alert-close"
              data-test="producer-alert-close"
              @click="$emit('close')"
            >Close</button>
          </div>

        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: ['footerConfirm', 'footerClose', 'allowSkip', 'skip'],
  created() {
    // Are we skipping this alert? Fire off confirm message immediately
    if (this.skip) {
      this.$emit('confirm');
    }
  },
};
</script>
